export default "__VITE_ASSET__BMCIjx1T__"